<template>
  <v-hover>
    <template #default="{ hover }">
      <Train :style="`position:relative; z-index: ${train_count - train_index}`">
        <!-- Hier Train milestones ausblenden -->
        <template v-if="getUObject({ type: 'projects', id: project_id }).showMilestones" #train-milestones>
          <!-- position: sticky; top: 400px;  -->
          <!-- HIER Z_INDEX RAUS; dann weißer strich weg -->
          <div class=""
            :style="`z-index: 1; position: sticky; top: calc((${getStatisticsHeight()}px + 130px) * var(--taktplan_zoom));display: flex; flex-direction: row; width: calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom) + var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom) + ${getProjectLength(project_id) + 1} * ((var(--workpackage_width) + 8px) * var(--taktplan_zoom))`">
            <TaktTimeHighLighter v-if="current_takt_index !== false &&
              $store.state.View.is_taktplan_takttime_highlight"
              :index="isSpatialView ? Math.abs(current_takt_index) : Math.abs(current_takt_index) + 1"
              header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
              z_index="1" />
            <TaktTimeHighLighter v-if="current_takt_index !== false &&
              current_takt_index >= 0 &&
              $store.state.View.is_taktplan_takttime_highlight"
              :index="isSpatialView ? current_takt_index + 1 : current_takt_index + 2"
              header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
              z_index="1" />
            <!-- MILESTONE HIGHLIGHT -->
            <template
              v-if="$store.state.View.is_taktplan_milestone_highlight && getUObject({ type: 'projects', id: project_id }).showMilestones">
              <TaktTimeHighLighter v-for="milestone, i in getMileStones(project_id)"
                :key="`takt-plan-milestone-highlight-${i}`" :index="milestone.takt_index.index + 1"
                header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px - 1px"
                border_style="dashed" />
              <TaktTimeHighLighter v-for="pmilestone, i in getPMileStones(project_id)"
                :key="`takt-plan-pmilestone-highlight-${i}`" :index="pmilestone.takt_index.index + 1"
                header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px - 1px"
                border_style="dashed" />
            </template>
            <!-- /MILESTONE HIGHLIGHT -->
            <HeaderRow style="flex-shrink: 0"
              :class="hover && ['TrainMilestonesAdd', 'TrainMilestonesEdit'].includes($route.name) ? 'border-white-hover cursor-pointer' : !isEditMode ? 'cursor-pointer' : ''"
              :z_index="6"
              width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom) + var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom)) "
              sticky_left="0px" :key="`trainname${train.id}`" color="color-1-5" :text="train.name"
              :readonly="hover && isEditMode && $route.name === 'ProjectTaktPlan' ? false : true" @changeValue="updateUObject({
                url: train_url,
                update: {
                  name: $event
                }
              })">
            </HeaderRow>
            <!-- <div style="width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom)); flex-shrink: 0"/> -->
            <!-- Buffer left side -->
            <MileStonesLane
              v-if="!backlog"
              :style="`min-height: 0px; height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom) - 1px) ;width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom)); flex-shrink: 0`"
              class="" justify_content="center" lane_height="1px" :hasLine="true" lane_color="#757575" />
            <!-- <div style="margin-left: calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom) + var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom) + (var(--workpackage_width) + 8px) * var(--taktplan_zoom));"> -->
            <!-- milestone lane -->
            <MileStonesLane
              v-if="!backlog"
              :style="`min-height: 0px; height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom) - 1px) ;width: calc(${getProjectLength(project_id) + 1} * ((var(--workpackage_width) + 8px) * var(--taktplan_zoom)); flex-shrink: 0`"
              class="cursor-pointer" justify_content="center" :hasLine="true" lane_height="1px" lane_color="#757575"
              @click.native="$router.push({ name: 'TrainMilestones' })">
              <template v-for="milestone in getMileStones(project_id)">
                <MileStone v-if="milestone.trains.includes(train.id)" :key="milestone.milestone.id"
                  :token="milestone.milestone.token"
                  :status="getTrainMilestoneStatus({ milestone_id: milestone.milestone.id, project_id })"
                  :zoom="$store.state.View.taktplan_zoom" type="train" :z_index="5" :takt_index="milestone.takt_index"
                  :offset_y="milestone.offset_y" :distance_min="milestone.distance_min"
                  @click.native.prevent.stop="$router.push({ name: 'TrainMilestonesDetails', params: { milestone_id: milestone.milestone.id } })" />
              </template>
              <MileStone v-if="getNewMilestone(project_id).trains.includes(train.id)" type="new-train"
                :takt_index="getNewMilestone(project_id).takt_index" :token="getNewMilestone(project_id).milestone.token"
                :large="true" :z_index="5" />
            </MileStonesLane>

            <!-- </div> -->
          </div>
        </template>
        <template #train>
          <!-- PRINT GRID COLUMN -->
          <!-- NOTE: rows are handled in the TPTaktarea style attribute -->
          <template v-if="$store.state.View.is_taktplan_grid_column">
            <TaktTimeHighLighter v-for="index in getCalendar(project_id).takt_times.length + 1"
              :id="`print-column${index}`" :key="`print-column${index}`" :index="index"
              header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px - 1px"
              z_index="1" style="opacity: .25;" />
          </template>
          <!-- /PRINT GRID COLUMN -->
          <draggable :key="`taktareas${train.id}`" animation="300" forceFallback="true" fallbackOnBody="true"
            :disabled="!hover || draggable_disabled || train.closed || !isEditMode || $route.name !== 'ProjectTaktPlan' ? true : false"
            :value="train[taktareas_string]" handle=".swap-arrow-2" @update="($event.newIndex - $event.oldIndex !== 0) ? updateUObjectPosition({
              url: backlog ?
                [
                  { projects: project_id },
                  { wbgroups: train.id },
                  { wblines: train.wblines[$event.oldIndex] },
                ]
                :
                [
                  { projects: project_id },
                  { trains: train.id },
                  { taktareas: train.taktareas[$event.oldIndex] },
                ],
              update: {
                position: $event.newIndex - $event.oldIndex
              }
            }) : ''"
            @start="dragging_ta_id = `${backlog ? 'wblines' : 'taktareas'}${train[backlog ? 'wblines' : 'taktareas'][$event.oldIndex]}`"
            @end="dragging_ta_id = -1">
            <TPTaktarea v-for="(taktarea, taktarea_index) in taktareas"
              :key="`${backlog ? 'wblines' : 'taktareas'}${taktarea.id}`" :draggable_disabled="draggable_disabled"
              :train="train" :train_index="train_index" :location="location" :taktarea="taktarea"
              :taktarea_index="taktarea_index" :taktarea_count="taktareas.length" :project_id="project_id"
              :new_milestone="new_milestone" :milestone_selection="milestone_selection" :snackbar="snackbar"
              :dragging_ta="(dragging_train && taktarea_index === 0) || dragging_ta_id === `${backlog ? 'wblines' : 'taktareas'}${taktarea.id}`"
              :backlog="backlog" :is_last="taktarea_index === taktareas.length - 1" :style="taktplan_grid_row"
              :current_takt_index="current_takt_index"
              @toggleDraggable="$emit('toggleDraggable', $event)" />
          </draggable>
        </template>
      </Train>
    </template>
  </v-hover>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { MilestonesMixin } from '@/mixins/Milestones.mixin.js';

import draggable from "vuedraggable";

import HeaderRow from '@/components/ProjectTaktPlan/HeaderRow.component.vue';

import Train from '@/components/ProjectTaktPlan/Train.component.vue';
import TPTaktarea from '@/views/Project/ProjectTaktPlan/TPTaktarea.wrapper.vue';

import TaktTimeHighLighter from '@/components/ProjectTaktPlan/TaktTimeHighLighter.component.vue'
import MileStonesLane from '@/components/ProjectTaktPlan/MileStonesLane.component.vue'
import MileStone from '@/components/ProjectTaktPlan/MileStone.component.vue'

export default {
  props: [
    'project_id',
    'train',
    'train_index',
    'train_count',
    'draggable_disabled',
    'new_milestone',
    'milestone_selection',
    'snackbar',
    'location',
    'dragging_train',
    'backlog',
    'current_takt_index',
  ],
  components: {
    HeaderRow,
    draggable,
    Train,
    TPTaktarea,
    MileStonesLane,
    MileStone,
    TaktTimeHighLighter
  },
  mixins: [
    MilestonesMixin,
  ],
  data: () => ({
    dragging_ta_id: -1,
  }),
  // updated() {
  //   console.log('tptrain updated');
  // },
  computed: {
    taktareas_string() {
      if (this.location === 'HistProject') {
        if (this.backlog) {
          return 'histwblines';
        } else {
          return 'histtaktareas';
        }
      } else {
        if (this.backlog) {
          return 'wblines';
        } else {
          return 'taktareas';
        }
      }
    },
    taktareas() {
      let taktareas = [];
      if (this.location === 'HistProject') {
        if (this.backlog) {
          taktareas = this.getUObjects({type: 'histwblines', ids: this.train.histwblines});
        } else {
          taktareas = this.getUObjects({type: 'histtaktareas', ids: this.train.histtaktareas});
        }
      } else {
        if (this.backlog) {
          taktareas = this.getUObjects({type: 'wblines', ids: this.train.wblines});
        } else {
          taktareas = this.getUObjects({type: 'taktareas', ids: this.train.taktareas});
        }
      }

      if (this.$store.state.View.taktarea_filter) {

        // store this.$store.state.View.taktarea_filter separated by ; in filter variable
        let filter = this.$store.state.View.taktarea_filter.split(';');

        // filter taktareas by an additive filter for name and description
        taktareas = taktareas.filter(taktarea => {
          let filter_result = false;
          filter.forEach(filter_item => {
            if (taktarea.name.toLowerCase().includes(filter_item.toLowerCase()) ||
              taktarea.description.toLowerCase().includes(filter_item.toLowerCase())) {
              filter_result = true;
            }
          });
          return filter_result;
        });
        
      }
        
      
      return taktareas;

    },
    ...mapGetters('Ultra', [
      'getUObjectsFiltered',
      'getUObjects',
      'getUObject',
    ]),
    ...mapGetters('ProjectCalendar', [
      // 'getCurrentTaktIndex',
      'getCalendar',
    ]),
    ...mapGetters('Project', [
      'isEditMode',
      'getProjectLength',
    ]),
    ...mapGetters('View', [
      'isSpatialView',
    ]),
    train_url() {
      if (this.backlog) {
        return [
          { projects: this.project_id },
          { wbgroups: this.train.id },
        ]
      } else {
        return [
          { projects: this.project_id },
          { trains: this.train.id },
        ]
      }
    },
    taktplan_grid_row() {
      let style = '';
      if (this.$store.state.View.is_taktplan_grid_row) {
        style += 'border-bottom: 1px dashed ';
        if (this.$vuetify.theme.isDark) {
          style += 'rgba(255, 255, 255, 0.25)';
        }
        else {
          style += 'rgba(0, 0, 0, 0.25)';
        }
        style += ';'
      }
      return style;
    },
  },
  methods: {
    ...mapActions('Ultra', [
      'updateUObjectPosition',
      'updateUObject'
    ]),
    getStatisticsHeight() {
      let stat_blurr = document.getElementById('statistics_background_blurr');
      if (stat_blurr) {
        return stat_blurr.clientHeight;
      }
      return 0;
    },
  }
}
</script>
<style>
.class {}
</style>
